import { Box, Button, Divider } from '@mui/material';
import { toast } from 'react-hot-toast';
import { useAuth } from 'hooks/useAuth';

export const LogoutButton = ({
  handleClose
}) => {

  const { logout } = useAuth();

  const handleLogout = async () => {
    try {
      handleClose();
      logout();
    } catch (err) {
      // console.error(err);
      toast.error("Não deu pra deslogar!");
    }
  };

  return (
    <>
      <Divider sx={{ mx: 3, my: 0}} />
      <Box p={3}>
        <Button
          fullWidth
          variant="outlined"
          color="primary"
          onClick={handleLogout}
        >
          Sair
        </Button>
      </Box>
    </>
  )
}